import React, { useCallback } from "react";
import { createKds, updateKdsMappings } from "apis";
import { useApi } from "hooks";
import { mapObject } from "services";
import { kdsRequest } from "mappers";
import KdsForm from "../kds-form/kds-form.module";

const CreateKds = () => {
  const { request: createRequest, loading: creating } = useApi({
    api: createKds,
    handleOwnError: { badrequest: true },
  });
  const { request: mappingRequest } = useApi({
    api: updateKdsMappings,
    handleOwnError: { badrequest: true },
  });

  const submit = useCallback(
    async (params) => {
      const payload = mapObject(params, kdsRequest);
      const response = await createRequest(payload);
      const data = response?.data || response;
      const kdsId = data?.kdsId || data?.id;
      if (kdsId) {
        await mappingRequest({
          kdsId,
          venueId: params.venueId,
          outletId: params.outletId,
          category_ids: params.category_ids || [],
          product_ids: params.product_ids || [],
          sku_ids: params.sku_ids || [],
        });
      }
      return { message: `${params.name} created` };
    },
    [createRequest, mappingRequest]
  );

  return <KdsForm title={"Create KDS"} submitting={creating} submit={submit} />;
};

export default CreateKds;

